import React, { PropTypes } from 'react';
import classNames from 'classnames';

const DropZone = ({show, loading}) => {
  return (
    <div className={classNames('drop-zone', {'conseal': !show})} id="drop-zone">
      <div className="drop-text text-muted">
        <h3>{'Drop Excel filen din her.'}</h3>
      </div>
    </div>
  );
};

DropZone.propTypes = {
  show: PropTypes.bool,
  loading: PropTypes.bool,
};

export default DropZone;



/** WEBPACK FOOTER **
 ** ./src/components/club/DropZone.js
 **/